export enum SettingsCardType {
	AgentTemplates = 'agentTemplates',
	Blitzes = 'blitzes',
	CallAnalysis = 'callAnalysis',
	Categories = 'categories',
	DashAndReports = 'dashAndReports',
	EmailSignature = 'emailSignature',
	EmailTemplates = 'emailTemplates',
	Gamification = 'gamification',
	Goals = 'goals',
	IssuesLog = 'issuesLog',
	ManageUsers = 'manageUsers',
	Password = 'password',
	PhoneNumbers = 'phoneNumbers',
	PrizesLog = 'prizesLog',
	ScenarioManagement = 'scenarioManagement',
	SlotMachinePrizes = 'slotMachinePrizes',
	SlotMachines = 'slotMachines',
	StartABlitz = 'startABlitz',
	Utilities = 'utilities',
	Voicemail = 'voicemail',
}

export enum SettingsSectionType {
	Account = 'account',
	Calling = 'calling',
	CallingSetup = 'callingSetup',
	Coaching = 'coaching',
	CoachingAndAi = 'coachingAndAi',
	Gamification = 'gamification',
	Reporting = 'reporting',
	Rewards = 'rewards',
	YourAccount = 'yourAccount',
}

export interface ISettingsCard {
	description: string;
	href?: string; // external link
	section: SettingsSectionType;
	settingType: SettingsCardType;
	text: string;
	to?: string; // internal link
}

export const AdminSettingsCards: ISettingsCard[] = [
	{
		description: 'Memes that play for each activity',
		section: SettingsSectionType.Gamification,
		settingType: SettingsCardType.Gamification,
		text: 'Gamification',
	},
	{
		description: 'Timed calling sprints for the team',
		section: SettingsSectionType.Gamification,
		settingType: SettingsCardType.Blitzes,
		text: 'Blitzes',
	},
	{
		description: 'Goals by rep and date range',
		section: SettingsSectionType.Gamification,
		settingType: SettingsCardType.Goals,
		text: 'Goals',
	},
	{
		description: 'Prizes each slot machine can award',
		section: SettingsSectionType.Gamification,
		settingType: SettingsCardType.SlotMachines,
		text: 'Slot Machines',
	},
	{
		description: 'Your spins and prizes won',
		section: SettingsSectionType.Gamification,
		settingType: SettingsCardType.SlotMachinePrizes,
		text: 'Slot Machine Prizes',
		to: '/slotmachine/prizes',
	},
	{
		description: "Prizes won and whether they're paid",
		section: SettingsSectionType.Gamification,
		settingType: SettingsCardType.PrizesLog,
		text: 'Prizes Log',
	},
	{
		description: 'AI agents reps practise calls with',
		section: SettingsSectionType.CoachingAndAi,
		settingType: SettingsCardType.AgentTemplates,
		text: 'Sales AI Agents',
	},
	{
		description: 'How recorded calls are scored',
		section: SettingsSectionType.CoachingAndAi,
		settingType: SettingsCardType.CallAnalysis,
		text: 'Call Analysis',
	},
	{
		description: 'Practice scenarios and skill areas',
		section: SettingsSectionType.CoachingAndAi,
		settingType: SettingsCardType.ScenarioManagement,
		text: 'Scenario Management',
	},
	{
		description: 'Team dashboards and reports',
		section: SettingsSectionType.Reporting,
		settingType: SettingsCardType.DashAndReports,
		text: 'Dash & Reports',
	},
	{
		description: 'Lead issues reps have reported',
		section: SettingsSectionType.Reporting,
		settingType: SettingsCardType.IssuesLog,
		text: 'Issues Log',
	},
	{
		description: 'Numbers your reps call from',
		section: SettingsSectionType.CallingSetup,
		settingType: SettingsCardType.PhoneNumbers,
		text: 'Phone Numbers',
	},
	{
		description: 'Your voicemail greeting',
		section: SettingsSectionType.CallingSetup,
		settingType: SettingsCardType.Voicemail,
		text: 'Voicemail',
		to: '/user/voicemail',
	},
	{
		description: 'Categories for call recordings',
		section: SettingsSectionType.CallingSetup,
		settingType: SettingsCardType.Categories,
		text: 'Categories',
	},
	{
		description: 'Profile pictures, config uploads and lead exports',
		section: SettingsSectionType.CallingSetup,
		settingType: SettingsCardType.Utilities,
		text: 'Utilities',
	},
	{
		description: 'Templates your team sends',
		href: `${import.meta.env.VITE_APP_URL}/#/templates`,
		section: SettingsSectionType.Account,
		settingType: SettingsCardType.EmailTemplates,
		text: 'Email Templates',
	},
	{
		description: 'Users, roles and access',
		href: `${import.meta.env.VITE_APP_URL}/#/settings/admin/manage-users`,
		section: SettingsSectionType.Account,
		settingType: SettingsCardType.ManageUsers,
		text: 'Manage Users',
	},
].filter(s => (import.meta.env.PROD && s.settingType === SettingsCardType.SlotMachinePrizes ? false : true));

export const UserSettingsCards: ISettingsCard[] = [
	{
		description: 'Change your password',
		href: `${import.meta.env.VITE_APP_URL}/#/settings/password`,
		section: SettingsSectionType.YourAccount,
		settingType: SettingsCardType.Password,
		text: 'Password',
	},
	{
		description: 'Your email signature',
		href: `${import.meta.env.VITE_APP_URL}/#/settings/email-signature`,
		section: SettingsSectionType.YourAccount,
		settingType: SettingsCardType.EmailSignature,
		text: 'Signature',
	},
	{
		description: 'Your voicemail greeting',
		section: SettingsSectionType.Calling,
		settingType: SettingsCardType.Voicemail,
		text: 'Voicemail',
		to: '/user/voicemail',
	},
	{
		description: 'How recorded calls are scored',
		section: SettingsSectionType.Coaching,
		settingType: SettingsCardType.CallAnalysis,
		text: 'Call Analysis',
	},
	{
		description: 'Your spins and prizes won',
		section: SettingsSectionType.Rewards,
		settingType: SettingsCardType.SlotMachinePrizes,
		text: 'Slot Machine Prizes',
		to: '/slotmachine/prizes',
	},
];

const AchievementSettings = [
	SettingsCardType.PrizesLog,
	SettingsCardType.SlotMachinePrizes,
	SettingsCardType.SlotMachines,
];

const LevitateSalesCoffeeSettings = [SettingsCardType.AgentTemplates, SettingsCardType.ScenarioManagement];

interface ISettingsVisibility {
	achievementsEnabled: boolean;
	isAdmin: boolean;
	isLevitateSalesCoffeeAccount: boolean;
}

export const getVisibleSettingsCards = ({
	achievementsEnabled,
	isAdmin,
	isLevitateSalesCoffeeAccount,
}: ISettingsVisibility) => {
	return (isAdmin ? AdminSettingsCards : UserSettingsCards).filter(
		card =>
			(achievementsEnabled || !AchievementSettings.includes(card.settingType)) &&
			(isLevitateSalesCoffeeAccount || !LevitateSalesCoffeeSettings.includes(card.settingType))
	);
};
